import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class CustomerInvoiceBillingCodeMarkupBus extends BaseBus {
    constructor(busObj: BaseBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);

    }

    CID(): any {
        return this.customerInvoiceBillingCodeMarkupId;
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setFromForm(data: CustomerInvoiceBillingCodeMarkupBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        this.updateDt = dateNow;
        this.updateUserId = data.insertUserId;
        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    customerInvoiceBillingCodeMarkupId: string;
    billingCodeId: string;
    billingCode: string;
    description: string;
    customerId: string;
    locationId: string;
    markup: number;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
}